<template>
  <div
    ref="filter"
    :class="[$style.filter, { [$style.filterShow]: isFilterShowed }, { [$style.dropdownShow]: isDropdownShown }]"
  >
    <div :class="[$style.header]">
      <div :class="[$style.wrapper]">
        <div :class="$style.buttonWrap">
          <template>
            <base-button :class="[$style.button, $style.choice]" @click="toggleDropdown">
              <span v-if="filterList.length && !isMobile">Отрасль и задача: {{ filterList.join(' / ') }}</span>
              <span v-if="!filterList.length">Выбрать отрасль и задачу</span>
              <span v-if="filterList.length && isMobile"> Отрасль и задача ({{ filterList.length }}) </span>
            </base-button>
          </template>
          <template v-if="!isFilterEmpty">
            <base-button :class="[$style.button, $style.inverted]" @click="clearFilter">Показать все кейсы</base-button>
          </template>
        </div>
        <h3 :class="$style.title" v-show="isFilterEmpty">Все кейсы</h3>
      </div>
    </div>

    <div :class="[$style.dropdown]">
      <div :class="[$style.container]">
        <div :class="[$style.wrapper]">
          <div :class="$style.col">
            <h3 :class="$style.title">Отрасли</h3>
            <CasesCheckbox
              v-for="industry in industries"
              :group="'industries'"
              :item="industry"
              :key="industry.id"
              :filter="filter"
            />
          </div>
          <div :class="$style.col">
            <h3 :class="$style.title">Задачи</h3>
            <CasesCheckbox v-for="task in tasks" :group="'tasks'" :item="task" :key="task.id" :filter="filter" />
          </div>
          <div :class="$style.buttonWrap">
            <base-button @click="showSelectedCases" :class="$style.button">Показать выбранные кейсы</base-button>
            <base-button @click="clearFilter" :class="[$style.button, $style.inverted]">Показать все кейсы</base-button>
          </div>
          <base-button :class="$style.close" @click="toggleDropdown">
            <span>Закрыть</span>
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'huntkit/hunt-kit.css';
import CasesCheckbox from './CasesCheckbox.vue';
import { BaseButton } from 'huntkit';
import { BREAKPOINTS } from '~scripts/core/breakpoints';
import { getScrollbarWidth } from '~scripts/core/helpers';

export default {
  name: 'CasesFilter',
  components: {
    BaseButton,
    CasesCheckbox,
  },
  props: {
    isScrollToFilter: {
      type: Boolean,
      default: false,
    },
    industries: {
      type: Array,
      required: true,
    },
    tasks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filter: {
        industries: [],
        tasks: [],
      },
      isMobile: false,
      isFilterShowed: false,
      isDropdownShown: false,
    };
  },
  mounted() {
    this.mediaSm.addListener(this.handleMediaChange);
    this.handleMediaChange(this.mediaSm);
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.handleClickOutside);
  },
  computed: {
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaSm() {
      return window.matchMedia(`(max-width: ${this.breakpoints.smMax})`);
    },
    showDropdownOnly() {
      return this.isScrollToFilter;
    },
    isFilterEmpty() {
      const { filter } = this;
      return filter.industries.length === 0 && filter.tasks.length === 0;
    },
    filterList() {
      const { filter } = this;
      let industries = filter.industries.map((item) => item.title);
      let tasks = filter.tasks.map((item) => item.title);
      return [...industries, ...tasks];
    },
  },
  methods: {
    showSelectedCases() {
      this.$emit('dataSent', this.filter);

      this.toggleDropdown();
    },
    clearFilter() {
      this.closeDropdown();

      for (let key in this.filter) {
        this.filter[key] = [];
      }

      this.$emit('dataSent', this.filter);
    },
    toggleDropdown() {
      setTimeout(() => {
        const header = document.querySelector('#header');
        document.querySelector('body').classList.toggle('is-dropdown-shown');

        this.isDropdownShown = !this.isDropdownShown;
        this.isDropdownShown ? this.lockScroll() : this.enableScroll();

        if (window.scrollY === 0 && this.isDropdownShown) {
          header.classList.add('header--shadow');
        }
        if (window.scrollY === 0 && !this.isDropdownShown) {
          header.classList.remove('header--shadow');
        }
      }, 10);
    },
    closeDropdown() {
      document.querySelector('body').classList.remove('is-dropdown-shown');
      this.isDropdownShown = false;
      this.enableScroll();
    },
    lockScroll() {
      document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`);
      document.body.classList.add('no-scroll');
    },
    enableScroll() {
      document.body.classList.remove('no-scroll');
      document.documentElement.style.removeProperty('--scrollbar-width');
    },
    handleScroll() {
      const element = document.querySelector('#casesApp');
      const reviewSection = document.querySelector('.js-review');
      const position = element.getBoundingClientRect().top;

      this.isFilterShowed = position < 100 && reviewSection.getBoundingClientRect().top - 250 >= 0;
    },
    handleClickOutside(event) {
      if (!this.$refs.filter.contains(event.target) && this.isDropdownShown) {
        this.toggleDropdown();
      }
    },
    handleMediaChange(event) {
      this.isMobile = event.matches;
    },
  },
};
</script>

<style lang="scss">
body {
  position: relative;

  &::after {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background-color: #fff;
    opacity: 0;
    transition: 0.4s;
    pointer-events: none;
    visibility: hidden;
    content: '';
  }
}

.is-dropdown-shown {
  &::after {
    opacity: 0.5;
    visibility: visible;
    pointer-events: auto;
  }
}
</style>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

$xlh: 1441px;

.button {
  box-shadow: unset !important;
  white-space: nowrap;

  &:not([disabled], .inverted):hover {
    background: #000;
  }
}

.inverted {
  background: rgba(235, 237, 242, 0.6);
  color: vars.$colorBase;

  @include mixins.hover {
    &:hover {
      background: rgba(235, 237, 242, 1);
    }
  }
}

.header {
  position: fixed;
  z-index: 20;
  top: 64px;
  right: vars.$scrollbarWidth;
  left: 0;
  background-color: #fff;
  transform: translateY(-100%);
  transition:
    transform 0.4s,
    opacity 0.2s;
  opacity: 0;

  @include mixins.media($xlh) {
    top: 72px;
  }

  .wrapper {
    @include mixins.container;

    display: flex;
    align-items: center;
    justify-content: space-between;

    @include mixins.media(sm, max) {
      max-width: 100%;
    }

    @include mixins.media(md) {
      max-width: 740px;
      padding: 0;
    }

    @include mixins.media(lg) {
      max-width: 1000px;
    }

    @include mixins.media(xl) {
      max-width: 1170px;
    }
  }

  .title {
    @include mixins.font(1.6rem, 1);

    display: none;
    opacity: 0.5;
    white-space: nowrap;
    font-weight: vars.$fontWeightBase;

    @include mixins.media(md) {
      display: inline;
    }
  }

  .buttonWrap {
    width: 100%;
    padding: 6px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include mixins.media(sm, max) {
      gap: 4px;
    }

    @include mixins.media(md) {
      padding: 12px 0;
    }

    button {
      @include mixins.media(sm, max) {
        width: 100%;
        padding: 5px 0;
      }

      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .counter {
        @include mixins.media(md) {
          display: none;
        }
      }
    }
  }

  .button {
    @include mixins.font(1.4rem, 1.55);

    height: 36px;
    padding: 5px 12px;
    border-radius: 32px;

    @include mixins.media(md) {
      @include mixins.font(1.6rem, 1.55);

      height: 33px;
      padding: 4px 12px;
      cursor: pointer;
    }
  }

  .choice {
    @include mixins.media(sm, max) {
      width: 100%;
    }
    @include mixins.media(md) {
      max-width: calc(100% - 190px);
    }
    span {
      display: block;
    }
  }
}

.dropdown {
  position: fixed;
  z-index: 10;
  top: 64px;
  right: vars.$scrollbarWidth;
  left: 0;
  background-color: #fff;
  transition: transform 0.4s;

  @include mixins.media(sm, max) {
    position: fixed;
    z-index: 2000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 3.6rem 2rem 25rem 2rem;
    background-color: #fff;
    opacity: 0;
    overflow-x: hidden;
    overflow-y: auto;
    transition: unset;
    visibility: hidden;
  }

  @include mixins.media(md) {
    margin: 0 auto;
    will-change: transform, scroll-position;
    transform: translateY(-100%);
  }

  @include mixins.media($xlh) {
    top: 72px;
  }

  .wrapper {
    @include mixins.media(md) {
      position: relative;
      display: grid;
      padding: 12px 0;
      gap: 8px;
      opacity: 0;
      grid-template-columns: repeat(2, 1fr);
      transition: 0.1s;
    }
  }

  .container {
    margin: 0 auto;

    @include mixins.media(md) {
      max-width: 740px;
      border-bottom: 2px solid #e6e5ec;
    }
    @include mixins.media(lg) {
      max-width: 1000px;
    }

    @include mixins.media(xl) {
      max-width: 1170px;
    }
  }

  .col {
    @include mixins.media(md) {
      width: 50%;
    }

    & + .col {
      @include mixins.media(sm, max) {
        margin-top: 28px;
      }
    }
  }

  .title {
    @include mixins.font(1.6rem, 1);

    display: inline-block;
    margin-bottom: 16px;
    opacity: 0.5;
    font-weight: vars.$fontWeightBase;

    @include mixins.media(md) {
      margin-bottom: 24px;
    }
  }

  .buttonWrap {
    margin-top: 36px;

    @include mixins.media(sm, max) {
      position: fixed;
      z-index: 10;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 24px 20px;
      background-color: #fff;
      box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.08);
    }

    @include mixins.media(md) {
      display: grid;
      width: 100%;
      margin-top: 28px;
      gap: 8px;
      grid-column-end: 3;
      grid-column-start: 1;
      grid-template-columns: repeat(2, 1fr);
    }

    button {
      height: 40px;
      padding: 11px 12px;

      @include mixins.media(sm, max) {
        @include mixins.size(100%, 48px);

        margin-bottom: 8px;
      }
    }
  }

  .close {
    position: absolute;
    box-shadow: unset;

    @include mixins.media(sm, max) {
      @include mixins.size(20px);

      top: 22px;
      right: 22px;
      padding: initial;
      background-color: initial;
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.2'%3E%3Cpath d='M2 2L22.0024 22.0024' stroke='%233A3A8D' stroke-width='3.12537'/%3E%3Cpath d='M22.002 2L1.99957 22.0024' stroke='%233A3A8D' stroke-width='3.12537'/%3E%3C/g%3E%3C/svg%3E%0A");
      background-size: contain;
      border-radius: initial;
    }

    @include mixins.media(md) {
      top: 15px;
      right: 0;
      height: 33px;
      padding: 4px 12px;
      background-color: rgba(235, 237, 242, 0.6);
      border-radius: 31px;
      color: #1d1d1f;

      @include mixins.hover {
        &:hover {
          background: rgba(235, 237, 242, 1);
        }
      }
    }

    span {
      @include mixins.media(sm, max) {
        display: none;
      }
    }
  }
}

.filterShow {
  .header {
    transform: translateY(0%);
    will-change: opacity, transform;
    opacity: 1;
    visibility: visible;
    transition:
      transform 0.4s,
      opacity 0.2s;
  }

  .dropdown {
    @include mixins.media(md) {
      transform: translateY(calc(-100% + 60px));
    }
  }
}

.dropdownShow {
  .header {
    opacity: 0;
    transition:
      transform 0.4s,
      opacity 0.2s 0.2s;
    visibility: hidden;
  }

  .dropdown {
    opacity: 1;

    @include mixins.media(sm, max) {
      transition: 0.2s;
      visibility: visible;
    }

    @include mixins.media(md) {
      transform: translateY(0%);
    }

    .wrapper {
      @include mixins.media(md) {
        opacity: 1;
        transition: 0.2s;
      }
    }
  }
}
</style>
